/*
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-31 15:37:25
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-31 15:37:44
 * @FilePath: \vnlin\oms\src\api\analysis\agentExceptionList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/exception'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})